var bpfrpt_proptype_SelectOptionValueProp = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
var bpfrpt_proptype_SelectOptionProp = {
    displayText: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
import PropTypes from "prop-types";
export { bpfrpt_proptype_SelectOptionValueProp };
export { bpfrpt_proptype_SelectOptionProp };